import * as types from './constants';

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = types.FORM_TYPES.GLOBAL, action) {
  switch (action.type) {
    case types.SET_SELECTED_FORM:
      return action.formType;
    default:
      return state;
  }
}
